import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import HowWork from '../../../assets/fn-how-work/how_work.png'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMHowWork: React.FC = () => {

    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#FFFDF7'
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                paddingTop: '80px',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingBottom: '60px'
            }}>
                <Image src={HowWork} width={isTablet ? 500 : 606} height={isTablet ? 534 : 647} style={{borderRadius: '10px', objectFit: 'cover'}} alt='' preview={false}></Image>
                <Box width={isTablet ? 30 : 72}></Box>
                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'start',
                    flexDirection: 'column'
                }}>
                    <Typography color={'#141F39'} fontSize={32} fontWeight={700} textAlign={'left'}>
                        {t('t41')}
                    </Typography>

                    <Typography color={'#141F39'} fontSize={16} fontWeight={400} textAlign={'left'} paddingTop={'0px'}>
                        {t('t42')}
                    </Typography>

                    {/* 01 */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '40px'
                    }}>
                        <Box width={70} height={70} sx={{
                            border: '1px solid #FBBF23',
                            borderRadius: '35px',
                            alignContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'center'}>
                                01
                            </Typography>
                        </Box>
                        <Box sx={{
                            flex: '1',
                            paddingLeft: '25px'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'left'}>
                                {t('t43')}
                            </Typography>

                            <Typography color={'#6B6B6B'} fontSize={16} fontWeight={400} textAlign={'left'}>
                                {t('t44')}
                            </Typography>
                        </Box>
                    </Box>

                    {/* 02 */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '40px'
                    }}>
                        <Box width={70} height={70} sx={{
                            border: '1px solid #FBBF23',
                            borderRadius: '35px',
                            alignContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'center'}>
                                02
                            </Typography>
                        </Box>
                        <Box sx={{
                            flex: '1',
                            paddingLeft: '25px'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'left'}>
                                {t('t45')}
                            </Typography>

                            <Typography color={'#6B6B6B'} fontSize={16} fontWeight={400} textAlign={'left'}>
                                {t('t46')}
                            </Typography>
                        </Box>
                    </Box>

                    {/* 03 */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '32px',
                    }}>
                        <Box width={70} height={70} sx={{
                            border: '1px solid #FBBF23',
                            borderRadius: '35px',
                            alignContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'center'}>
                                03
                            </Typography>
                        </Box>
                        <Box sx={{
                            flex: '1',
                            paddingLeft: '25px'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'left'}>
                                {t('t47')}
                            </Typography>

                            <Typography color={'#6B6B6B'} fontSize={16} fontWeight={400} textAlign={'left'}>
                                {t('t48')}
                            </Typography>
                            </Box>
                    </Box>

                    {/* 04 */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        paddingTop: '32px'
                    }}>
                        <Box width={70} height={70} sx={{
                            border: '1px solid #FBBF23',
                            borderRadius: '35px',
                            alignContent: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'center'}>
                                04
                            </Typography>
                        </Box>
                        <Box sx={{
                            flex: '1',
                            paddingLeft: '25px'
                        }}>
                            <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'left'}>
                                {t('t49')}
                            </Typography>

                            <Typography color={'#6B6B6B'} fontSize={16} fontWeight={400} textAlign={'left'}>
                                {t('t50')}
                            </Typography>
                        </Box>
                    </Box>

                </Box>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMHowWork
